import reactDom from "react-dom";
import App from './components/App'
import React from "react";
import './style.css'

reactDom.render(<App/>, document.querySelector('.root'))